var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"modal-field-multiple","size":"xl","title":"Pilih Parameter Pemeriksaan Klinik","hide-footer":""}},[_c('Table',{attrs:{"purpose":"modal-field-multiple","fieldCollection":_vm.fieldCollection},on:{"unCheckField":_vm.unCheckField,"chooseField":_vm.chooseField}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }